import Loader from "../../components/Loader/Loader";

export default function DeleteModal({ onCancel, onConfirm, isDeleting, error }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-8 max-w-md w-[90vw]">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Delete stamp
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to delete this stamp? This cannot be undone.
        </p>
        {error && (
          <div className="mb-4 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        )}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:border-gray-900 hover:text-gray-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isDeleting ? <Loader /> : "Confirm Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
